





































































































































































import {Component, Vue} from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {
    getFenqunList,
    verifyFenqun,
    deleteFenqun
} from "@/services/api"
import {TFenqunVO} from "@/model/TFenqunVO";
import { toastFailMessage } from "@/i18n/failMessage";
import {PageInfo} from "@/model/Resp";

@Component({
    components: {
        'yc-aside': YcAside,
        'yc-header': YcHeader
    },
})
export default class UserGrouping extends Vue {
    public tableData: TFenqunVO[] = [];
    public pageInfo: PageInfo = {
        currentPage: 1,
        pageSize: 20,
        total: 0
    }
    public setTimeApi = 0;
    public dialogVisible = false;
    timer:any = null

    public createType:'setting'|'upload' = 'setting';

    created(): void {
        this.getFenqunList(true);
        this.timer = setInterval(() => {
                this.getFenqunList(false)
        }, 1000 * 10);
    }
    beforeDestroy(): void{
        clearTimeout(this.setTimeApi)
        clearTimeout(this.timer)
    }

    /**
     * 获取联系人列表
     */
    getFenqunList(isLoad: boolean): void {

        getFenqunList({currentPage: this.pageInfo.currentPage, pageSize:this.pageInfo.pageSize}, isLoad)
          .then(res => {
              this.tableData = res.data.data;
              clearTimeout(this.setTimeApi)
              if (this.tableData.map(item=>item.status).indexOf(2) !== -1) {
                  this.setTimeApi = setTimeout(()=>{
                      this.getFenqunList(false);
                  }, 5000)
              }
              if (res.data.pageInfo) {
                  this.pageInfo = res.data.pageInfo;
              }
          })
    }
    /**
     * 查询
     */
    search(): void {
        this.pageInfo.currentPage = 1;
        this.getFenqunList(true);
    }

    /**
     * 分页大小变化
     * @param val
     */
    handleSizeChange(val: number): void {
        this.pageInfo.pageSize = val;
        this.pageInfo.currentPage = 1;
        this.getFenqunList(true);
    }

    /**
     * 当前页面变化
     * @param val
     */
    handleCurrentChange(val: number): void {
        this.pageInfo.currentPage = val;
        this.getFenqunList(true);
    }

    /**
     * 删除用户群
     */
    async deleteGroup(id: number) {
        const res = await verifyFenqun({id}, true);
        if (res.data.data && res.data.data.verifyDelete) {
            await this.$confirm(
              this.$tx('segment.list.deleteThisSegmentThisAction', '确定删除该用户群吗？删除后无法恢复！'),
              this.$tx('campaign.pkg.deleteThisFlow', '确定删除吗？'),
              {customClass:'modalOk'}
              );
            const res2 = await deleteFenqun({id}, true);
            if (res2.data.data.deleteStatus) {
                this.$message.success(this.$tx('flow.editor.deleteOk', '删除成功！'));
                this.getFenqunList(true);
            } else {
                this.$message.error(toastFailMessage(res2.data));
            }
        } else {
            const campaignList = res.data.data.campaignList||[];
            const flowList = res.data.data.flowList||[];
            const style = ` height: 22px;
                display: block;
                width: 370px;
                color: #165DFF;
                font-weight: 400;
                font-size: 14px;
                line-height: 22px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;`
            this.$alert(`
                    ${campaignList.length > 0 ? this.$tx('segment.list.pThisSegmentIsUsed', '<p>该用户群存在于营销活动：<br>') + campaignList.slice(0,6).map(campaign => `<a style="${style}" alt="" href="/cartsee-new/campaign/setting/${campaign.id}">${campaign.name}</a></p>`).join(' ') : ''}
                    ${flowList.length > 0 ? this.$tx('segment.list.pThisSegmentIsUsed2', '<p>该用户群存在于营销流程：<br>') + flowList.slice(0,6).map(flow => `<a style="${style}" alt="" href="/strategy/flow/${flow.id}">${flow.name}</a></p>`).join(' ') : ''}
                `, this.$tx('segment.list.cannotDelete', '无法删除'),{
                customClass: 'delete-error-box',
                center: true,
                type: 'error',
                dangerouslyUseHTMLString: true,
            })
        }
    }
}
